/* Draw GeoJSON

Iterates through the latitude and longitude values, converts the values to XYZ coordinates,
and draws the geoJSON geometries.

*/

/* eslint-disable no-console*/
/* eslint-disable no-unused-vars*/
const THREE = require('three')

function convertToSphereCoords(lat, lon, sphere_radius) {
  return [Math.cos(lat * Math.PI / 180) * Math.cos(lon * Math.PI / 180) * sphere_radius,
          Math.cos(lat * Math.PI / 180) * Math.sin(lon * Math.PI / 180) * sphere_radius,
          Math.sin(lat * Math.PI / 180) * sphere_radius];

}

export default {
  getPathFromArray(coordinates, radius) {
    var points = [];

    points.push(...convertToSphereCoords(Math.min(coordinates[0][0],coordinates[1][0]), Math.min(coordinates[0][1],coordinates[1][1]), radius))
    points.push(...convertToSphereCoords(Math.max(coordinates[0][0],coordinates[1][0]), Math.min(coordinates[0][1],coordinates[1][1]), radius))
    points.push(...convertToSphereCoords(Math.max(coordinates[0][0],coordinates[1][0]), Math.max(coordinates[0][1],coordinates[1][1]), radius))
    points.push(...convertToSphereCoords(Math.min(coordinates[0][0],coordinates[1][0]), Math.max(coordinates[0][1],coordinates[1][1]), radius))
    points.push(...convertToSphereCoords(Math.min(coordinates[0][0],coordinates[1][0]), Math.min(coordinates[0][1],coordinates[1][1]), radius))
    let geometry = new THREE.BufferGeometry();
    geometry.addAttribute( 'position', new THREE.Float32BufferAttribute( points, 3 ) );
    geometry.computeBoundingSphere();
    return geometry;
  },

  parseGeoJsonFeature(json, radius, ) {
    // create a simple square shape. We duplicate the top left and bottom right
    // vertices because each vertex needs to appear once per triangle.
    var features = [];
    for(var j=0; j<json.coordinates.length; j++){
      var points = [];
      let geometry = new THREE.BufferGeometry();
      for(var i=0; i<json.coordinates[j].length;i++){
        //

        let p = convertToSphereCoords(json.coordinates[j][i][1],json.coordinates[j][i][0], radius);
        if(!(isNaN(p[0]) || isNaN(p[1]) || isNaN(p[2]) )){
          points.push(p[0]);
          points.push(p[1]);
          points.push(p[2]);
        }
      }
      geometry.addAttribute( 'position', new THREE.Float32BufferAttribute( points, 3 ) );
      geometry.computeBoundingSphere();
      features.push({geometry:geometry, length:points.length, start:Math.random()*0.85, duration:Math.min(0.15, Math.max(0.01, 0.1*points.length/27995))})
    }
    return features;
  },

  parseStaticGeoJsonFeature(json, radius) {
    // create a simple square shape. We duplicate the top left and bottom right
    // vertices because each vertex needs to appear once per triangle.
    var features = [];
    let geometry = new THREE.BufferGeometry();
    var points = [];
    var indices = [];
    var index = 0;
    for(var j=0; j<json.coordinates.length; j++){
      for(var i=0; i<json.coordinates[j].length;i++){
        let p = convertToSphereCoords(json.coordinates[j][i][1],json.coordinates[j][i][0], radius);
        if(!(isNaN(p[0]) || isNaN(p[1]) || isNaN(p[2]) )){
          points.push(p[0]);
          points.push(p[1]);
          points.push(p[2]);
          if(index>0 && i>0){
            indices.push(index-1);
            indices.push(index);
          }
          index++;
        }
      }
    }
    geometry.addAttribute( 'position', new THREE.Float32BufferAttribute( points, 3 ) );
    geometry.setIndex(new THREE.BufferAttribute( new Uint32Array(indices), 1 ) );
    geometry.computeBoundingSphere();
    features.push({geometry:geometry, length:points.length, start:Math.random()*0.85, duration:Math.min(0.15, Math.max(0.01, 0.1*points.length/27995))})
    return features;
  }
};
